import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import TrainingModule from "../../models/trainingModule";
import { TrainingModuleInfo } from "../TrainingModuleInfo/TrainingModuleInfo";
import { Button } from "../ui/Button/Button";
import { Typography } from "../ui/Typography/Typography";
import { IconTypes } from "../ui/icons";
import { Icon } from "../ui/icons/Icon";
import "./TrainingModuleAccordion.scss";

interface TrainingModuleAccordionProps {
  trainingModule: TrainingModule;
}

export const TrainingModuleAccordion = ({
  trainingModule,
}: TrainingModuleAccordionProps) => {
  return (
    <Accordion className="TrainingModuleAccordion">
      <AccordionSummary
        expandIcon={
          <Button icon color="secondary">
            <Icon type={IconTypes.NavArrow} color="secondary" />
          </Button>
        }
      >
        <TrainingModuleInfo trainingModule={trainingModule} />
      </AccordionSummary>
      <AccordionDetails className="TrainingModuleAccordion__details">
        {trainingModule.touchPoints.map((touchpoint) => (
          <div
            key={touchpoint.referenceId}
            className="TrainingModuleAccordion__details__item"
          >
            <Typography desktop="body2" weight="bold">
              {touchpoint.title}
            </Typography>
            <Typography desktop="body2" color="secondary">
              {touchpoint.description}
            </Typography>
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
